import React, {useEffect, useState} from 'react'
import ShowMore from '../../../components/ShowMore'
import MeetingReservation from './MeetingReservation'
import {MEETING_SPACES_SHOW} from '../../../constants/const'
import {renderGrouping, groupReservations} from './helpers'
import {
  fetchMeetingRoomReservations,
  meetingRoomCheckInOut
} from '../../../api/reservations'
import styled from 'styled-components'
import {useUserState} from '../../../context/UserContext'
import {useUIDispatch} from '../../../context/UIContext'

import {isServiceCatalog} from '../../../utils/routing'

const fetchReservations = async ({emId, numberOfRecordsToFetch}) => {
  const reservations = await fetchMeetingRoomReservations({
    employee: emId,
    numberOfRecords: numberOfRecordsToFetch
  })

  return reservations
}

const MeetingListContainer = ({truncated}) => {
  const {user} = useUserState()
  const uiDispatch = useUIDispatch()
  const [reservations, setReservations] = useState({data: [], total: 0})
  const numberOfRecordsToFetch = truncated ? 1 : 1000
  const emId = user.employee.id
  const isCatalogView = isServiceCatalog()

  useEffect(
    () => {
      let didCancel = false
      fetchReservations({emId, numberOfRecordsToFetch}).then(reservations => {
        if (!didCancel) {
          setReservations(reservations)
        }
      })

      return () => {
        didCancel = true
      }
    },
    [emId, numberOfRecordsToFetch]
  )

  const {data: meetingReservations, total: numberOfRecords} = reservations

  const showMeetingReservation = reservation =>
    uiDispatch({
      type: 'setContent',
      payload: {
        content: MEETING_SPACES_SHOW,
        props: {room: reservation},
        parentPage: isCatalogView ? 'SERVICE_CATALOG' : 'DASHBOARD'
      }
    })

  const doCheckInCheckOut = async reservation => {
    await meetingRoomCheckInOut(reservation)
    const reservations = await fetchReservations({emId, numberOfRecordsToFetch})
    setReservations(reservations)
  }
  const onCheckIn = reservation => {
    reservation.verified = 1
    doCheckInCheckOut(reservation)
  }

  const onCheckOut = reservation => {
    reservation.verified = 0
    doCheckInCheckOut(reservation)
  }

  const onShowMore = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'MEETINGS_MORE_LIST', parentPage: 'DASHBOARD'}
    })

  let groupedReservations = groupReservations(meetingReservations)

  // TODO: The meeting list could be large, use the virtual list component to render the list.

  return (
    <ListContainer>
      {Object.keys(groupedReservations).map(group => (
        <div key={group}>
          {renderGrouping(group)}
          <div>
            {groupedReservations[group].map(meeting => (
              <MeetingReservation
                key={meeting.reserveResId}
                meeting={meeting}
                onCheckIn={onCheckIn}
                onCheckOut={onCheckOut}
                onClick={showMeetingReservation}
              />
            ))}
          </div>
        </div>
      ))}

      {truncated && (
        <ShowMore recordCount={numberOfRecords} onClick={onShowMore} />
      )}
    </ListContainer>
  )
}

export default MeetingListContainer

const ListContainer = styled.div`
  max-width: 1200px;
  flex: 1;
  background-color: #ffffff;
  border-radius: 5px;
  overflow-y: scroll;

  @media (max-width: 420px) {
    border-radius: 0;
  }
`
